if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

(function initSizeGuideModal() {
  const openers = document.querySelectorAll('[data-size-guide-open]');
  if (!openers.length) return;

  let activeModal = null;
  const pullToCloseThreshold = 80;

  const getModal = (sectionId) => {
    if (!sectionId) return document.querySelector('.size-guide-modal');
    return document.getElementById(`SizeGuideModal-${sectionId}`) || document.querySelector('.size-guide-modal');
  };

  const openModal = (modal) => {
    if (!modal) return;
    attachPullToClose(modal);
    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('size-guide-modal-open');
    activeModal = modal;
    const focusTarget = modal.querySelector('[data-size-guide-focus]') || modal.querySelector('.size-guide-modal__sheet');
    focusTarget && focusTarget.focus({ preventScroll: true });
  };

  const closeModal = () => {
    if (!activeModal) return;
    activeModal.classList.remove('is-active');
    activeModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('size-guide-modal-open');
    activeModal = null;
  };

  const attachPullToClose = (modal) => {
    const sheet = modal?.querySelector('.size-guide-modal__sheet');
    if (!sheet || sheet.dataset.pullCloseAttached) return;
    sheet.dataset.pullCloseAttached = 'true';
    let startY = null;
    let dragging = false;

    const onStart = (evt) => {
      if (sheet.scrollTop > 0) return;
      const touch = evt.touches ? evt.touches[0] : evt;
      startY = touch.clientY;
      dragging = true;
    };

    const onMove = (evt) => {
      if (!dragging || startY === null) return;
      const touch = evt.touches ? evt.touches[0] : evt;
      const diff = touch.clientY - startY;
      if (diff > pullToCloseThreshold) {
        dragging = false;
        startY = null;
        closeModal();
      }
    };

    const onEnd = () => {
      dragging = false;
      startY = null;
    };

    sheet.addEventListener('touchstart', onStart, { passive: true });
    sheet.addEventListener('touchmove', onMove, { passive: true });
    sheet.addEventListener('touchend', onEnd, { passive: true });
    sheet.addEventListener('mousedown', onStart);
    sheet.addEventListener('mousemove', onMove);
    sheet.addEventListener('mouseup', onEnd);
  };

  openers.forEach((button) => {
    button.addEventListener('click', () => {
      const modal = getModal(button.dataset.sizeGuideSection);
      openModal(modal);
    });
  });

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-size-guide-open]');
    if (opener) {
      event.preventDefault();
      const modal = getModal(opener.dataset.sizeGuideSection);
      openModal(modal);
      return;
    }
    if (!activeModal) return;
    if (event.target.closest('[data-size-guide-close]')) {
      closeModal();
      return;
    }

    const sheet = activeModal.querySelector('.size-guide-modal__sheet');
    if (sheet && !sheet.contains(event.target)) {
      closeModal();
    }
  });

  openers.forEach((button) => attachPullToClose(getModal(button.dataset.sizeGuideSection)));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeModal();
    }
  });
})();
